// TODO move this to some utility package so that the file is available
// for all packages in the monorepo
const DEFAULT_CURRENCY_DECIMAL_COUNT = 2;
// Stripe's currency data as of September 2025 (https://docs.stripe.com/currencies)
const CURRENCY_RULES = {
    zeroDecimals: [
        'BIF',
        'CLP',
        'DJF',
        'GNF',
        'JPY',
        'KMF',
        'KRW',
        'MGA',
        'PYG',
        'RWF',
        'UGX',
        'VND',
        'VUV',
        'XAF',
        'XOF',
        'XPF',
    ],
    minimumPriceUnitAmounts: {
        AED: 500,
        AUD: 200,
        BGN: 200,
        BRL: 500,
        CAD: 200,
        CHF: 100,
        CZK: 2000,
        DKK: 500,
        EUR: 100,
        GBP: 100,
        GIP: 100,
        HKD: 1000,
        HUF: 40000,
        JPY: 200,
        MXN: 2000,
        MYR: 500,
        NOK: 1000,
        NZD: 200,
        PLN: 500,
        RON: 500,
        SEK: 1000,
        SGD: 100,
        THB: 4000,
        USD: 100,
    },
};
const getCurrencyDecimalCount = (currency) => {
    return CURRENCY_RULES.zeroDecimals.includes(currency.toUpperCase())
        ? 0
        : DEFAULT_CURRENCY_DECIMAL_COUNT;
};
const getPriceRange = (currency) => {
    const DEFAULT_MULTIPLIER = 5;
    const MAX_MULTIPLIER = 50;
    const minUnitAmount = CURRENCY_RULES.minimumPriceUnitAmounts[currency.toUpperCase()];
    if (minUnitAmount === undefined) {
        throw new Error(`Currency ${currency} not supported`);
    }
    return {
        defaultUnitAmount: minUnitAmount * DEFAULT_MULTIPLIER,
        minUnitAmount,
        maxUnitAmount: minUnitAmount * MAX_MULTIPLIER,
    };
};
const getFullAmount = (unitAmount, currency) => {
    const divisor = 10 ** getCurrencyDecimalCount(currency);
    return unitAmount / divisor;
};
const getUnitAmount = (fullAmount, currency) => {
    const multiplier = 10 ** getCurrencyDecimalCount(currency);
    return fullAmount * multiplier;
};
const formatUnitAmount = (unitAmount, currency, options) => {
    const formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        ...options,
    });
    return formatter.format(getFullAmount(unitAmount, currency));
};
const formatUnitAmountWithoutSymbol = (unitAmount, currency) => {
    const decimalCount = getCurrencyDecimalCount(currency);
    return getFullAmount(unitAmount, currency).toFixed(decimalCount);
};

export { formatUnitAmount, formatUnitAmountWithoutSymbol, getCurrencyDecimalCount, getFullAmount, getPriceRange, getUnitAmount };
//# sourceMappingURL=exports.mjs.map
